import React, { useEffect, useState } from 'react'; // Added useEffect
import { useLocation } from 'react-router-dom'; // Added useLocation and Navigate
import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../../provider';
import { saveToken } from '../../utils/auth';
import { PATHS } from '../../router/routes';
import { getFrontendBaseUrl } from '../../utils';

const SIGNIN_BY_TOKEN_MUTATION = gql`
    mutation SignInByToken($token: String!) {
        signinByToken(token: $token) {
            ... on AuthTokenType {
                token {
                    token
                }
                refreshToken {
                    token
                }
                user {
                    id
                    email
                    firstName
                    lastName
                    isAgentCreated
                    isFinishedStepper
                    isSubscribed
                    # Add other user fields you need here if required by redirection logic
                }
            }
            ... on ErrorType {
                message
            }
        }
    }
`;

const SignInByToken = () => {
    // Removed useState for token input
    const { setAuthToken } = useAuth();
    const location = useLocation(); // Get location object
    const [statusMessage, setStatusMessage] = useState('Loading...'); // State for UI feedback
    const [signIn, { error }] = useMutation(SIGNIN_BY_TOKEN_MUTATION, {
        onCompleted: (data) => {
            if (data.signinByToken?.__typename === 'AuthTokenType') {
                const { token, user } = data.signinByToken;
                if (token?.token && user?.email) {
                    setAuthToken(token.token);
                    saveToken(token.token);
                    localStorage.setItem('email', user.email);
                    setStatusMessage('Redirecting...');
                    const backendBaseUrl = getFrontendBaseUrl();
                    const targetPath = PATHS.MY_AGENT;
                    window.location.href = backendBaseUrl ? `${backendBaseUrl}${targetPath}` : targetPath;

                } else {
                    console.error('Sign in completed but missing token or user email.');
                    setStatusMessage('Sign in failed: Invalid response from server.');
                }
            } else if (data.signinByToken?.__typename === 'ErrorType') {
                console.error('Sign in error:', data.signinByToken.message);
                setStatusMessage(`Sign in failed: ${data.signinByToken.message}`);
            } else {
                console.error('Sign in error: Unexpected response structure', data);
                setStatusMessage('Sign in failed: Unexpected error.');
            }
        },
        onError: (apolloError) => {
            console.error('Apollo error during sign in:', apolloError);
            setStatusMessage(`Sign in error: ${apolloError.message}`);
        },
    });

    // useEffect to trigger sign-in on mount
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenFromUrl = params.get('token');

        if (tokenFromUrl) {
            setStatusMessage('Signing in...');
            signIn({ variables: { token: tokenFromUrl } });
        } else {
            setStatusMessage('Error: Token not found in URL.');
        }
    }, [location.search, signIn]); // Depend on location search and signIn function


    // Render status message
    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h1>Sign In Status</h1>
            <p>{statusMessage}</p>
            {/* Display error details if an Apollo error occurred */}
            {error && !statusMessage.startsWith('Sign in failed:') && (
                <p style={{ color: 'red' }}>Details: {error.message}</p>
            )}
        </div>
    );
};

export default SignInByToken;